import {
    Handler,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { GetProductVariantChildrenApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    PopulateApiParameter as PopulateApiParameterToOverride,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadVariantChildren";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";

// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(() => {
        chain.length = 0;
        originalChain.forEach((original) => chain.push(original));
    });
}

type Parameter = { productId: string } & HasOnSuccess<ProductModel[]>;
type Props = {
    apiParameter: GetProductVariantChildrenApiV2Parameter;
    apiResult: ProductCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        productId: props.parameter.productId,
        pageSize: 500,
        expand: ["content", "documents", "specifications", "attributes", "badges", "properties", "detail"],
        includeAttributes: ["includeOnProduct"],
    };
};

replaceInChain(
    chain,
    PopulateApiParameterToOverride,
    PopulateApiParameter
);